
<template>
  <div class="signup">
    <form method="post" v-on:submit.prevent="subscribe">
      <input type="email" class="form-control" placeholder="Your email" aria-label="Your email here" v-model="email" name="email" autocomplete="off" required="required">
      <button class="btn btn-primary" :disabled="!email ||  status !== ''">Sign up</button>
    </form>
  </div>
</template>


<script>

export default {
    data() {
      return {
        email: '',
        status:'',
      }
    },
    methods: {
      subscribe() {
        if (this.email) {
          this.status = 'saving';
          var self = this;

          this.$store.dispatch('subscribe', {
            sub: { email: this.email }, callback(res) {
              self.status = '';

              if (res.errors) {
                Toast.error(res.errors[0]);
              } else {
                Toast.success('Thanks! We\'ve added you to our mailing list');
                self.email = '';
              }
            }
          });
        }
      }
    }
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .signup { width: 300px; margin-top: 14px; }
    .signup input { max-width: 234px; float: left; height: 40px; border-radius: 0px; }
    .signup .btn { width: 66px; float: left; border-radius: 0px; background: #191c21;color:#FFFFFF;border:0px;line-height:40px;}

  @media (max-width: 992px) {
    .signup { margin:14px auto 0px auto;float:none;}
      .signup input {}
  }
</style>



// WEBPACK FOOTER //
// SubscribeForm.vue?887c3986